export type ViewerMode = 'inspect' | 'annotate' | 'replay'

export const parseViewerMode = (raw: string | null): ViewerMode =>
  raw === 'annotate' || raw === 'replay' ? raw : 'inspect'

export const viewerHref = (meetingId: string, mode: ViewerMode): string => {
  const base = `/app/attribution/${encodeURIComponent(meetingId)}`
  return mode === 'inspect' ? base : `${base}?mode=${mode}`
}

export const annotateHref = (meetingId: string): string => viewerHref(meetingId, 'annotate')
export const compareHref = (meetingId: string): string => `/app/attribution/${encodeURIComponent(meetingId)}/compare`
